module.exports = __webpack_public_path__ + "img/cr.74dd61b.svg";